import { Component, OnInit } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
    selector: 'app-dqf-document-skeleton',
    templateUrl: './dqf-document-skeleton.component.html',
    styleUrls: ['./dqf-document-skeleton.component.scss'],
    standalone: true,
    imports: [NgxSkeletonLoaderModule]
})
export class DqfDocumentSkeletonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
